import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReceipt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.05275 5.2762H9.51942M6.05275 8.80476H9.51942M13.1998 14.5V2.36667C13.1998 2.13682 13.1085 1.91637 12.946 1.75384C12.7835 1.59131 12.563 1.5 12.3331 1.5H3.66647C3.43662 1.5 3.21617 1.59131 3.05365 1.75384C2.89112 1.91637 2.7998 2.13682 2.7998 2.36667V14.5L4.53314 12.7667L6.26647 14.5L7.9998 12.7667L9.73314 14.5L11.4665 12.7667L13.1998 14.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgReceipt;
